module.exports = __webpack_public_path__ + "img/asuransi-alatberat.3e509be6.svg";